interface SegmentedControlProps {
  segments: Array<{ value: string; label: string }>;
  value: string;
  onChange: (value: string) => void;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  segments,
  value,
  onChange,
}) => {
  return (
    <div
      className="flex items-center gap-0 rounded-full p-1"
      style={{ backgroundColor: 'var(--bg-secondary)' }}
    >
      {segments.map((segment) => (
        <button
          key={segment.value}
          onClick={() => onChange(segment.value)}
          className="flex-1 px-4 py-2 rounded-full transition-all text-[15px] font-medium"
          style={{
            backgroundColor: value === segment.value ? 'var(--accent)' : 'transparent',
            color: value === segment.value ? 'var(--accent-on)' : 'var(--text-hint)',
          }}
        >
          {segment.label}
        </button>
      ))}
    </div>
  );
};
